<template>
  <div class="component-container">
    <label v-if="showLabel()" :style="lableStyle"
      ><span class="xing" :style="required ? { color: '#f00' } : null">*</span
      >{{ label }}</label
    >
    <el-tooltip
      :disabled="disabledTooltip() || !isedite"
      :content="tooltip"
      placement="top-start"
    >
      <el-select
        :disabled="!isedite"
        :style="inputStyle"
        v-model="val"
        :filterable="options.length > 10"
        ref="component"
        :placeholder="lagplaceholder"
        @change="handleChange"
        popper-class="sel"
      >
        <el-option
          v-for="(item, index) in options"
          :key="index"
          :label="item.label"
          :value="item.value"
        />
      </el-select>
    </el-tooltip>
  </div>
</template>

<script>
import _ from 'lodash'
import * as constants from '@/constants'
import * as storage from '@/utils/storage'

export default {
  name: 'jtSelect',
  props: {
    label: {
      type: String,
      default: '',
    },
    labelWidth: {
      type: String,
      default: '30%',
    },
    value: {
      type: String,
      default: '',
    },
    tooltip: {
      type: String,
      default: '',
    },
    compWidth: {
      type: String,
      default: '100%',
    },
    options: {
      type: Array,
      required: true,
    },
    editable: {
      type: Boolean,
      default: true,
    },
    required: {
      type: Boolean,
      default: false,
    },
    alwaysEdit: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      val: this.value == '' ? null : this.value,
      lableStyle: {
        width: window.innerWidth > 768 ? this.labelWidth : '100%',
      },
      inputStyle: {
        width: window.innerWidth > 768 ? this.compWidth : '100%',
      },
      hasFiredEnterEventHandler: false,
      lagplaceholder:
        storage.getItem(constants.LANGUAGE) === '英文'
          ? 'SELECT'
          : storage.getItem(constants.LANGUAGE) === '中英文'
          ? '请选择/SELECT'
          : '请选择',
    }
  },
  watch: {
    value(newValue) {
      this.val = newValue
    },
  },
  computed: {
    isedite() {
      if (this.alwaysEdit) {
        return true
      } else {
        return this.editable
      }
    },
  },
  methods: {
    // changeLan(label) {
    //   if (this.$root.isdoubleLang) {
    //     let str = label
    //     if (label == 'AIN1') {
    //       str = 'RUS-Russia'
    //     } else if (label == 'AIN2') {
    //       str = 'BLR-Belarus'
    //     }
    //     return str
    //   } else {
    //     return label
    //   }
    // },
    showLabel() {
      return !_.isEmpty(_.trim(this.label))
    },
    focus() {
      this.$refs.component.focus()
    },
    disabledTooltip() {
      return _.isEmpty(_.trim(this.tooltip))
    },
    // handleVisibleChange(visible) {
    //   if (!visible) {
    //     this.$emit('enter')
    //     _.delay(() => this.$emit('datas', null, this.val), 300)
    //   }
    // },
    handleChange() {
      // this.$emit('enter')
      _.delay(() => this.$emit('datas', null, this.val), 300)
    },
  },
}
</script>

<style lang="stylus" >
.sel {
  .el-select-dropdown__wrap {
    max-height: 474px;
  }

  .el-select-dropdown__item.hover {
    background-color: #8cc5ff;
  }
}
</style>
    